/** Moved to `app/core/chat/ai-chat.service` so the messenger app shares it; re-exported here for existing importers. */
export * from 'app/core/chat/ai-chat.service';
